import { InputAdornment, Stack, TextField } from '@mui/material';
import React from 'react';
import { DynamicIcon } from 'src/components';
import { useScreenDimensions } from 'src/utils/system';

type SearchBarProps = {
  onSearch: (value: string) => void;
} & React.ComponentProps<typeof TextField>;

export const SearchBar: React.FC<SearchBarProps> = ({ onSearch, ...textFieldProps }) => {
  const { isMobile } = useScreenDimensions();

  return (
    <Stack flexDirection="column" width="100%">
      <TextField
        fullWidth
        autoFocus={!isMobile}
        placeholder="Search ProVision"
        type="text"
        size="medium"
        variant="standard"
        sx={{
          height: '3.3rem',
        }}
        onChange={(e) => {
          onSearch(e.target?.value);
        }}
        InputProps={{
          disableUnderline: true,
          sx: { height: '3.3rem', zIndex: 0 },
          startAdornment: (
            <InputAdornment position="start">
              <DynamicIcon
                name="Search"
                sx={{
                  width: '1.5rem',
                  height: '1.5rem',
                }}
              />
            </InputAdornment>
          ),
        }}
        {...textFieldProps}
      />
    </Stack>
  );
};
